import { FormCol, FormRow, InfoTooltip, SafeHtml, ToggleButtonListControl } from 'ia-react-core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DocumentPreference } from '../../../../../interfaces/DocumentPreference';
import { StyledToggleButtonListWrapper } from '../../CommunicationPreferencesForm.styles';

export interface DocumentPreferenceControlProps {
  preference: DocumentPreference;
}

const DocumentPreferenceControl: FC<DocumentPreferenceControlProps> = ({ preference }) => {
  const { t } = useTranslation('CommunicationPreferencesFormPage');

  const options = [
    { label: t('documentPreferences.option1'), value: { ...preference, preferenceValue: 1 }, key: 'preferenceValue' },
    { label: t('documentPreferences.option2'), value: { ...preference, preferenceValue: 2 }, key: 'preferenceValue', disabled: preference.type.isDisabled },
  ];

  const toolTip = preference.type.helpText ? <InfoTooltip tip={<SafeHtml>{preference.type.helpText}</SafeHtml>} /> : null;

  return (
    <FormRow>
      <FormCol label={preference.type.name} tip={toolTip} labelMarginBottom={36}>
        <StyledToggleButtonListWrapper>
          <ToggleButtonListControl
            name={`documentPreferences[${preference.type.id}]`}
            validate={(value) => ({
              required: !value?.preferenceValue,
            })}
            defaultValue={preference}
            options={options}
          />
        </StyledToggleButtonListWrapper>
      </FormCol>
    </FormRow>
  );
};

export default DocumentPreferenceControl;
